"use strict";
/**
 * @module Features.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of {@link SystemPrincipal}
 *
 * @inheritdoc
 */
var SecurityConfigurationImpl = /** @class */ (function () {
    /**
     * Create a SecurityConfigurationImpl instance
     *
     * @param  anonymous  the list of default roles for anonymous sessions
     * @param  named      the list of default roles for named sessions
     * @param  roles      the list of all defined roles
     * @param  isolatedPaths  the list of isolated paths
     */
    function SecurityConfigurationImpl(anonymous, named, roles, isolatedPaths) {
        this.anonymous = anonymous;
        this.named = named;
        this.roles = roles;
        this.isolatedPaths = isolatedPaths;
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the SecurityConfiguration
     *
     * tslint:disable-next-line:max-line-length
     */
    SecurityConfigurationImpl.prototype.toString = function () {
        // tslint:disable-next-line:max-line-length
        return 'SecurityConfiguration [anonymous=${this.anonymous}, named=${this.named}, roles=${this.roles}, isolatedPaths=${this.isolatedPaths}]';
    };
    return SecurityConfigurationImpl;
}());
exports.SecurityConfigurationImpl = SecurityConfigurationImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/security/security-configuration.js
// module id = 1274
// module chunks = 0